import { render, staticRenderFns } from "./CS-metadata-widget.vue?vue&type=template&id=563128d1"
import script from "./CS-metadata-widget.vue?vue&type=script&lang=js"
export * from "./CS-metadata-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports